﻿import { mapGetters, mapState } from 'vuex';
import { ajaxGet } from '../../utils/ajax';

export default {
    name: 'basketview',
    template: '#basketview-template',
    data: () => ({
        fixate: false,
        fixatedAt: 0,
        showLoader: false
    }),
    props: ['exitpageurl','redirecturl'],
    computed:
        Object.assign(
            mapState({
                address: state => state.offeringpage.addresslookup.selectedAddress,
                allProducts: state => state.offeringpage.products.available,
                isDoneSearching: state => state.offeringpage.products.isDoneSearching,
                selectedVariantCode: state => state.offeringpage.products.selectedVariant,
                vasLessAllowed: state => state.offeringpage.vasLessAllowed,
                price: state => state.offeringpage.price,
                minimumPriceForBindingPeriod: state => state.offeringpage.minimumPriceForBindingPeriod,
            }),
            mapGetters({
                otherProducts: 'otherProducts',
                otherVariants: 'otherVariants',
                selectedProduct: 'selectedProduct',
                selectedVariant: 'selectedVariant',
                selectedVAS: 'selectedVas'
            }), {
                isFixed() {
                    return this.fixate;
                },
                vasSelected() {
                    if(!this.selectedVAS) return 0;
                    return this.selectedVAS.length;
                },
                isPriceSet() {
                    return typeof this.price !== 'undefined' && this.price !== '';
                },
                hasVasSelected() {
                    return (this.vasSelected > 0 || this.selectedVariant.numberOfVas === 0);
                },
                speed() {
                    if (this.selectedProduct.code == 'MBB2') return this.selectedVariant.speedDown;
                    return this.selectedVariant.speedDown + "/" + this.selectedVariant.speedUp;
                }
            }
            
            ),
    methods: {
        addToBasket() {
          
            var isDealerLoggedInFooterVisible=document.getElementById('channel-header');

            if(isDealerLoggedInFooterVisible!=null)
            {
                var store=this.$store;
                var exitpagurl= this.exitpageurl;
                var redirectionURL=this.redirecturl;
                const url = String.format('/teliadk/accessofferingblock/CheckDealerLoggedIn');
                setTimeout(function() {
                    ajaxGet(url)
                        .then((json) => {
                            if (!json) {
                                return;
                            }
                            const data = JSON.parse(json);
                            if(data==true)
                            {
                                var modalOptions = [{ text: 'OK', action: 'redirect', url: redirectionURL }];
                                store.dispatch('showAlert',
                                    {
                                        size: 'large',
                                        header: '',
                                        body: 'Your session has been timed out, Please re-login',
                                        footer: '',
                                        hideButton: false,
                                        options: modalOptions
                                    });
                            }
                            else{

                                store.dispatch('addToBasket', exitpagurl);
                            }
                        })
                }, 100);
            }
            else{

                this.$store.dispatch('addToBasket',this.exitpageurl );
            }
           
            //this.showLoader = true;
			// redirect the browser after adding to the basket
        },
        scrollToAddressLookup() {
            this.$store.dispatch('showAddressMissingModal', true)
        },
        scrollToAddress()
        {
            var element = document.getElementById("addresslookup");
            var alignWithTop = false;
            element.scrollIntoView(alignWithTop);
        },
        removeFromBasket(vas) {
            this.$store.dispatch('deselectVAS', vas)
        },
        checkScroll() {
            var offsets = document.getElementById('basketview').getBoundingClientRect();
            var top = offsets.top;
            var left = offsets.left;
            var scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop; //Supports IE

            if(!this.fixate && top <= 0) {
                this.fixatedAt = scrollTop - 68;
                this.fixate = true;
            } else {
                if(this.fixatedAt > scrollTop) this.fixate = false;
            }
        },
        closepopup() {
            document.getElementById("showpopup").style.display="none";
        },
        },
    mounted: function() {
        //window.addEventListener('scroll', this.checkScroll);
        //if (document.querySelector('#channel-header')) {
        //    var elem = document.querySelector('#basketview');
        //    elem.style.bottom = "80px";
        //}
        
    }
    
}
